module.exports = __webpack_public_path__ + "static/img/logo5.b9c726bc.jpg";